import React from "react";
import { Link } from "react-router-dom";

import { localizer } from '../../../Translator'

import Container from '@material-ui/core/Container'
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import Paper from '@material-ui/core/Paper';
import { Backdrop, CircularProgress } from "@material-ui/core"
import { Button } from  "@material-ui/core"
import Typography from '@material-ui/core/Typography'
import { Grid } from "@material-ui/core";

import { UserRow } from "./UserRow";

import Roles from "../../Utilities/Roles"
import { TableCellStyled, TableRowHeaderStyled } from '../../common/TableStyled.js'
import { TableStyled } from '../../common/TableStyled.js'
import ScreenHeading from "../../common/ScreenHeading.js";

import AuthCli from "../../../sdk/AuthCli";

const USERS_PAGE_SIZE = 50

/**
 * Class component that represents the users list table.
 */
export class UsersTable extends React.Component {
    
  constructor(props) {
    super(props)
    this.state = {
      users: [],
      pagesLoaded: 0,
      endOfUsers: false,
      isLoading: false,
      usersError: null,
      usersRemoveError: null
    }
  }

  /**
   * It runs after the component output has been rendered to the DOM.
   * Gets first 50 users.
   */
  componentDidMount() {
    AuthCli.GetSessionInfo().then(session => {
      if (session) {
        if (session.role !== Roles.ROLE_ADMIN.Name) {
          window.location.href = "shipment"
        } else {
          this.loadNextPage()
        }
      }
    })
    //this.loadNextPage()
  }
  
  loadNextPage = () => {
    this.setState({ isLoading: true })
  
    AuthCli.GetBillableUsers(USERS_PAGE_SIZE, this.state.pagesLoaded).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ usersError: data.substring(data.indexOf(' ')) })
      }
      else {
        if (data.length > 0) {
          this.setState(previousState => ({
            users: [...previousState.users, ...data],
            pagesLoaded: previousState.pagesLoaded + 1,
            usersError: null
          }))
        }
        if (data.length < USERS_PAGE_SIZE) {
          this.setState({ endOfUsers: true, usersError: null })
        }
      }
      this.setState({ isLoading: false })
    })
  }

  render() {
    return (
      <React.Fragment>
        <Container maxWidth="xl">
         {/*  <GridHeaderComponent container direction="row">
            <Grid item md={9}>
              <Typography className="typography-generic header-title"><i className="fa-solid fa-users font-size-30"></i> {localizer.GroupUsers}</Typography>
            </Grid>
            <Grid item md={3} className="p-10" style={{ textAlign: "right" }}>
              <Button className="button-generic secondary-header" variant="contained" style={{ top: "calc(50% - 20px)" }} color="primary" component={Link} to="/invite"
                startIcon={<i className="fa-solid fa-user-plus"></i>}>
                {localizer.UsersHeaderButton}
              </Button>
            </Grid>
          </GridHeaderComponent> */}

          {/* Screen heading. */}
          <ScreenHeading className="typography-generic"
            icon={<i className="fa-solid fa-users icon-button-header mr-20 ml-20"></i>}
            title={localizer.GroupUsers}
            button={<Button className="button-generic secondary-header" variant="contained" style={{ top: "calc(50% - 20px)" }} color="primary" component={Link} to="/invite"
              startIcon={<i className="fa-solid fa-user-plus"></i>}>
              {localizer.UsersHeaderButton}
            </Button>}
          />

          <Grid container className="container-generic" direction="row" justify="center" alignItems="center" style={{ paddingTop: 25 }}>
            <TableContainer component={Paper}>
              <TableStyled aria-label="collapsible table">
                <TableHead>
                  <TableRowHeaderStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.User}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.UsersTableHeaderColumnPwdExpiration}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.UsersTableHeaderColumnLoginAttempts}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.UsersTableHeaderColumnLockout}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.UsersTableHeaderColumnLockoutEnd}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.UsersTableHeaderColumnlockedOutPermanent}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.AuthenticationFactor}</Typography></TableCellStyled>
                  </TableRowHeaderStyled>
                </TableHead>
                <TableBody>
                  {this.state.users && this.state.users.map((user) => (
                    <UserRow key={user.userId} user={user} />
                  ))}
                </TableBody>
              </TableStyled>
            </TableContainer>
          </Grid>
          <Grid container direction="row" justify="flex-end" style={{ paddingTop: 25 }}>
            <Button className="button-generic primary-load-element" variant="contained" onClick={this.loadNextPage} disabled={this.state.endOfUsers}>{localizer.LoadMore}</Button>
          </Grid>
        </Container>
          
        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/users/sections/UsersTable.js